import React from 'react';
import MuiMenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import {
  secondary50,
} from 'themes/colors';

const styles = theme => ({
  root: {
    minHeight: '2.5rem',
    color: theme.palette.secondary.text,
    backgroundColor: theme.palette.white,
    fontSize: '0.875rem',
    '&:hover': {
      backgroundColor: secondary50,
    },
  },
});


const MenuItem = (props) => {
  const { classes } = props;

  return (
    <MuiMenuItem
      classes={{ root: classes.root }}
      {...props}
    >
      {props.children}
    </MuiMenuItem>
  );
};

MenuItem.propTypes = {
  children: PropTypes.element.isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export default withStyles(styles)(MenuItem);
